/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var PlaceholderToken = /** @class */ (function () {
    function PlaceholderToken() {
    }
    PlaceholderToken.LeftHandlebars = "{{";
    PlaceholderToken.RightHandlebars = "}}";
    PlaceholderToken.EmptyName = "";
    return PlaceholderToken;
}());
export { PlaceholderToken };
